module.exports = __webpack_public_path__ + "img/txt-1-f.bb058d44.png";